import { reactive } from "vue";
import { PatientInfo } from "./models/user.model";

interface OTPStore {
    getLoginChallangeToken(): string | undefined;
    storeLoginChallangeToken(challenge_token: string): void;
    clearLoginChallangeToken(): void;
    getPatientID(): string | undefined;
    storePatientID(id: string): void;
    clearPatientID(): void;
}
const OTPstore: OTPStore = reactive({
    _challenge_token: undefined as string | undefined,
    _patient_id: undefined as string | undefined,
    
    storeLoginChallangeToken(challenge_token: string): void {
        this._challenge_token = challenge_token;
    },
    clearLoginChallangeToken(): void {
        delete this._challenge_token;
    },
    getLoginChallangeToken(): string | undefined {
        return this._challenge_token;
    },
    getPatientID(): string | undefined {
        return this._patient_id;
    },
    storePatientID(id: string): void {
        this._patient_id = id;
    },
    clearPatientID(): void {
        delete this._patient_id;
    },
})

export default OTPstore